import { ComponentType } from 'react';

import Loadable from '@townsquare/loadable';
import type { LoadableComponent } from '@townsquare/loadable/types';
import { RouteContext } from '@townsquare/router/routing-types';

export const StatusUpdatesView: ComponentType<RouteContext> & LoadableComponent = Loadable({
	loader: () => import(/* webpackChunkName: "StatusUpdatesView" */ './StatusUpdates'),
	loading: () => null,
});
